import { useState } from 'react';

// material-ui
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';

// project imports
import { useAuth } from 'contexts/AuthContext';

// assets
import CloseOutlined from '@ant-design/icons/CloseOutlined';

// Aviso de fim de sessão: aparece quando o JWT está para vencer e a renovação silenciosa não deu
// (no Safari o iframe não alcança a sessão do Entra). "Continuar conectado" renova por um popup do
// Entra, sem recarregar a página. Fechar no X esconde só este vencimento; se o próximo também não
// renovar sozinho, o aviso volta.
export default function AvisoSessaoExpirando() {
  const { sessaoExpiraEm, continuarConectado } = useAuth();
  const [renovando, setRenovando] = useState(false);
  const [erro, setErro] = useState<string | null>(null);
  const [fechadoPara, setFechadoPara] = useState<number | null>(null);

  if (!sessaoExpiraEm || fechadoPara === sessaoExpiraEm) return null;

  const hora = new Date(sessaoExpiraEm).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });

  // Nada de await antes de continuarConectado: o Safari só abre o popup durante o clique.
  const aoContinuar = () => {
    setErro(null);
    setRenovando(true);
    continuarConectado()
      .catch(() => setErro('Não deu para renovar a sessão. Salve o que estiver fazendo e entre de novo.'))
      .finally(() => setRenovando(false));
  };

  const rotulo = renovando ? 'Conclua na janela da Microsoft...' : erro ? 'Tentar de novo' : 'Continuar conectado';

  return (
    <Snackbar open anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
      <Alert
        severity={erro ? 'error' : 'warning'}
        variant="filled"
        action={
          <>
            <Button
              color="inherit"
              size="small"
              disabled={renovando}
              onClick={aoContinuar}
              startIcon={renovando ? <CircularProgress size={14} color="inherit" /> : null}
            >
              {rotulo}
            </Button>
            {!renovando && (
              <IconButton color="inherit" size="small" aria-label="Fechar aviso" onClick={() => setFechadoPara(sessaoExpiraEm)}>
                <CloseOutlined />
              </IconButton>
            )}
          </>
        }
        sx={{ alignItems: 'center' }}
      >
        {erro ?? `Sua sessão vence às ${hora}.`}
      </Alert>
    </Snackbar>
  );
}
